import { getDeviceType } from './device'

export const getResponsiveObject = (obj: any) => {
  if (!obj) {
    return
  }

  if (!obj?.attributes?.shared || !obj?.responsivity) {
    return { ...obj }
  }

  const deviceType: string = getDeviceType() as string

  const newObject = obj.attributes.shared[deviceType]
    ? { ...obj } // shared
    : {
        // unique
        ...obj,
        responsivity: obj[deviceType].responsivity || obj.responsivity,
        attributes: obj[deviceType].attributes || obj.attributes,
        layout: obj[deviceType].layout || obj.layout,
        relativeLayout: obj[deviceType].relativeLayout || obj.relativeLayout,
        innerWrapperStyles:
          obj[deviceType].innerWrapperStyles || obj.innerWrapperStyles,
      }

  return newObject
}
